<template>
    <vx-card title="Gifts">
        <div id="viewBannerLoadingDiv" class="vs-con-loading__container">
            <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort"
                v-model="selected" :data="gifts">
                <template slot="header">
                    <div class="flex flex-wrap items-center w-full mb-2">
                        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle"
                            @click="addBanner">Add a Gift</vs-button>
                    </div>
                </template>

                <template slot="thead">
                    <vs-th>Gift Name</vs-th>
                    <vs-th>Eligible coins</vs-th>
                    <vs-th>Status</vs-th>
                    <vs-th>Gift collected users</vs-th>
                    <vs-th>No of gift cards</vs-th>

                    <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                            <p v-if="data[indextr].name" color="none" class="product-order-status">
                                {{ data[indextr].name }}
                            </p>
                        </vs-td>
                        <vs-td :data="data[indextr].eligible_coins">
                            <p v-if="data[indextr].eligible_coins" color="none" class="product-order-status">
                                {{ data[indextr].eligible_coins }}
                            </p>
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip color="primary" class="product-order-status">
                                {{ data[indextr].status }}
                            </vs-chip>
                        </vs-td>

                        <vs-td :data="data[indextr].gift_collected_users">
                            <vs-row>
                                <vs-button @click="showUsers(data[indextr].gift_collected_users)" class="mr-2"
                                    color="danger" type="filled">
                                    {{ data[indextr].gift_collected_users.length }}
                                </vs-button>
                            </vs-row>

                        </vs-td>
                        <vs-td :data="data[indextr].no_of_gifts">
                            <p v-if="data[indextr].no_of_gifts" color="none" class="product-order-status">
                                {{ data[indextr].no_of_gifts }}
                            </p>
                        </vs-td>

                        <vs-td>
                            <vs-row>
                                <vs-button @click="editBanner(data[indextr])" class="mr-2" color="primary" type="border"
                                    icon-pack="feather" icon="icon-edit"></vs-button>
                                <vs-button @click="deleteGift(data[indextr])" color="danger" type="filled"
                                    icon-pack="feather" icon="icon-trash"></vs-button>
                            </vs-row>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-popup classContent="popup-example h-full" title="Add Gift" :active.sync="activePromptAddBanner">
                <div id="createBannerLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="addGiftForm">
                        <vs-divider position="left" class="mb-0">Gift name</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" placeholder="Enter gift name" name="gift_name"
                                    v-model="gift_name" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addGiftForm.gift_name')">{{
                                    errors.first('addGiftForm.gift_name') }}</span>
                            </div>
                        </div>

                        <vs-divider position="left" class="mb-0">Gift Description</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" placeholder="Enter gift description" name="gift_des"
                                    v-model="gift_des" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addGiftForm.gift_des')">{{
                                    errors.first('addGiftForm.gift_des') }}</span>
                            </div>
                        </div>

                        <vs-divider position="left" class="mb-0">Eligibility check coin count</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input type="number" v-validate="'required'"
                                    placeholder="Enter Eligibility check coin count" name="gift__coin" v-model="gift__coin"
                                    class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addGiftForm.gift__coin_')">{{
                                    errors.first('addGiftForm.gift__coin') }}</span>
                            </div>
                        </div>


                        <vs-divider position="left" class="mb-0">No of gifts cards</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input type="number" v-validate="'required'" placeholder="Enter number of gift cards"
                                    name="no_of_gifts" v-model="no_of_gifts" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addGiftForm.no_of_gifts')">{{
                                    errors.first('addGiftForm.no_of_gifts') }}</span>
                            </div>
                        </div>

                        <div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-12/12 mb-2">
                                Show / hide

                                <vs-switch class="w-full" color="success" v-model="isShow">

                                    <span slot="off">Hide</span>
                                    <span slot="on">Show</span>
                                </vs-switch>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div class="vx-col w-full mb-2">
                                <vs-button v-on:click.prevent="createGift()" color="primary" type="filled">Save
                                    Gift</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <vs-popup classContent="popup-example h-full" title="Edit Gifts" :active.sync="activePromptEditBanner">
                <div id="editBannerLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="editGiftForm">
                        <vs-divider position="left" class="mb-0">Gift name</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" placeholder="Enter gift name" name="gift_name"
                                    v-model="gift_name" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addGiftForm.gift_name')">{{
                                    errors.first('addGiftForm.gift_name') }}</span>
                            </div>
                        </div>

                        <vs-divider position="left" class="mb-0">Gift Description</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" placeholder="Enter gift description" name="gift_des"
                                    v-model="gift_des" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addGiftForm.gift_des')">{{
                                    errors.first('addGiftForm.gift_des') }}</span>
                            </div>
                        </div>

                        <vs-divider position="left" class="mb-0">Eligibility check coin count</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" placeholder="Enter Eligibility check coin count" name="gift__coin"
                                    v-model="gift__coin" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addGiftForm.gift__coin_')">{{
                                    errors.first('addGiftForm.gift__coin') }}</span>
                            </div>
                        </div>
                        <vs-divider position="left" class="mb-0">No of gifts cards</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input type="number" v-validate="'required'" placeholder="Enter number of gift cards"
                                    name="no_of_gifts" v-model="no_of_gifts" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addGiftForm.no_of_gifts')">{{
                                    errors.first('addGiftForm.no_of_gifts') }}</span>
                            </div>
                        </div>
                        <div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-12/12 mb-2">
                                Show / hide

                                <vs-switch class="w-full" color="success" v-model="isShow">

                                    <span slot="off">Hide</span>
                                    <span slot="on">Show</span>
                                </vs-switch>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div class="vx-col w-full mb-2">
                                <vs-button v-on:click.prevent="updateGift()" color="primary" type="filled">Update
                                    Gift</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>
            <!-- users data -->
            <vs-popup classContent="popup-example h-full wrap" title="Gift collected users"
                :active.sync="giftcollectedUserListModel">
                <div id="editBannerLoadingDiv" class="vs-con-loading__container">
                    <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort"
                        v-model="selected" :data="userData">


                        <template slot="thead">
                            <vs-th>Name</vs-th>
                            <vs-th>Email</vs-th>
                            <vs-th>Phone</vs-th>

                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextru" v-for="(tr, indextru) in data">

                                <vs-td :data="data[indextru].name">
                                    <div class="flex items-center">
                                        <!-- <vs-avatar :src="data[indextru].image" class="flex-shrink-0 mr-2" size="30px" -->

                                        <p v-if="data[indextru].name" color="none" class="product-order-status">
                                            {{ data[indextru].name }} {{ data[indextru].last_name }}
                                        </p>
                                    </div>
                                </vs-td>
                                <vs-td :data="data[indextru].email">

                                    <vs-button v-clipboard:copy="data[indextru].email"
                                        @click="copyText(data[indextru].email)" class="mr-2" color="danger" type="filled">
                                        {{ data[indextru].email }}
                                    </vs-button>

                                </vs-td>

                                <vs-td :data="data[indextru].phone">
                                    <p v-if="data[indextru].phone" color="none" class="product-order-status">
                                        {{ data[indextru].phone }}
                                    </p>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>


                    <!-- <vs-pagination :total="totalPages" :max="7" v-model="currentPage" /> -->
                </div>
            </vs-popup>

            <div class="vx-row mt-base">
                <div class="vx-col w-full mb-2">
                    <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import moduleGiftManagement from '@/store/gift_management/moduleGiftManagement.js'




export default {
    components: {
        vSelect,
        Treeselect,
    },
    computed: {

    },
    data() {
        return {
            usersData: [],
            gift_name: null,
            gift_des: null,
            gift__coin: null,
            no_of_gifts: null,
            isShow: true,
            gifts: [],
            update_gift_id: null,
            activePromptAddBanner: false,
            activePromptEditBanner: false,
            giftcollectedUserListModel: false,




            selected: [],
            key: null,
            active: null,
            search: null,
            totalPage: 1,
            currentPage: 1,

            deleteGiftData: null,





            image: [],
            fileRecordsForUpload: [],
            create_banner: true,
            update_banner: true,

            update_gift_name: null,
            selected_categories: [],
            bannerType: '',
            bannerTitle: '',
            bannerShowPages: [],
            myCroppa: {},
            myCroppa1: {},
        }
    },
    watch: {

        currentPage(val) {
            this.searchBanners()
            // console.log(val);
        }
    },
    async mounted() {

        await this.viewGifts()
        this.gifts = this.$store.state.giftManagement.gifts
        // await this.$store.dispatch("questionManagement/viewCategoryWithoutPaginate", { avoid_paginate: "true" })
    },

    methods: {
        copyText(email) {
            console.log(email)
            this.$vs.notify({
                title: "Email copied.",
                text: " Email copied successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });
        },
        redirectToAppPath(path) {
            window.open(path, "_blank");
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            // this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                var k = this.image.indexOf(fileRecord);
                if (k !== -1) this.image.splice(k, 1);
            } else {
                this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
        },
        fileDeleted: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(fileRecord);
            // var i = this.fileRecordsForUpload.indexOf(fileRecord);
            // if (i !== -1) {
            //     this.fileRecordsForUpload.splice(i, 1);
            // } else {
            //     this.deleteUploadedFile(fileRecord);
            // }
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        addBanner() {
            this.gift_name = null;
            this.activePromptAddBanner = true;
        },
        createGift() {
            this.$validator.validateAll('addGiftForm').then(result => {
                if (result) this.createGiftApi()
            })
        },
        async createGiftApi() {

            var self = this
            this.$vs.loading({
                container: '#createBannerLoadingDiv',
                scale: 0.6
            })
            let data = new FormData();
            data.append('id', this.update_gift_id);


            data.append('name', this.gift_name);
            data.append('description', this.gift_des);
            data.append('eligible_coins', this.gift__coin);
            data.append('no_of_gifts', this.no_of_gifts);
            data.append('status', this.isShow ? "show" : "hide");

            // for (var pair of data.entries()) {
            //     console.log(pair[0] + ', ' + pair[1]);
            // }
            // console.log(data);

            this.$store.dispatch("giftManagement/createGift", data)
                .then(res => {
                    console.log(res);
                    this.$vs.loading.close('#createBannerLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Gift created successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });



                    this.activePromptAddBanner = false;
                    this.viewGifts();

                })
                .catch(err => {
                    this.$vs.loading.close('#createBannerLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function (key) {
                        self.errors.add({
                            field: key,
                            scope: "addGiftForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },

        showUsers(userData) {
            // console.log(userData);
            var data = [];
            for (let index = 0; index < userData.length; index++) {

                data.push(userData[index].user);

            }
            // console.log(data);


            this.userData = data;
            this.giftcollectedUserListModel = true
        },

        editBanner(banner) {
            console.log(banner);
            this.gift_name = banner.name
            this.gift__coin = banner.eligible_coins;
            this.no_of_gifts = banner.no_of_gifts;
            this.gift_des = banner.description;
            this.update_gift_id = banner.id;
            this.isShow = banner.status == "show" ? true : false;
            this.activePromptEditBanner = true
        },
        updateGift() {
            this.$validator.validateAll('editGiftForm').then(result => {

                if (result) this.updateGiftApi()
            })
        },

        async updateGiftApi() {
            var self = this
            this.$vs.loading({
                container: '#editBannerLoadingDiv',
                scale: 0.6
            })

            let data = new FormData();
            data.append('id', this.update_gift_id);
            data.append('name', this.gift_name);
            data.append('description', this.gift_des);
            data.append('eligible_coins', this.gift__coin);
            data.append('no_of_gifts', this.no_of_gifts);
            data.append('status', this.isShow ? "show" : "hide");

            for (var pair of data.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }
            console.log(data);

            this.$store.dispatch("giftManagement/updateGift", data)
                .then(res => {
                    console.log(res);
                    this.$vs.loading.close('#editBannerLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Banner updated successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });


                    this.update_gift_id = null;
                    this.activePromptEditBanner = false;
                    // this.viewGifts();

                })
                .catch(err => {
                    this.$vs.loading.close('#editBannerLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function (key) {
                        self.errors.add({
                            field: key,
                            scope: "editGiftForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        deleteGift(place) {
            this.deleteGiftData = place;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this data ?',
                accept: this.acceptdeleteGift
            })
        },
        acceptdeleteGift() {
            this.$vs.loading();

            this.$store.dispatch("giftManagement/deleteGift", { id: this.deleteGiftData.id })
                .then(res => {
                    console.log(res);
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Banner deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.$vs.loading.close()
                })
        },


        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchBanners()
            }, 2000);
        },
        handleChangePage(page) {
            console.log(page);
            // this.searchUser()
        },
        handleSort(key, active) {
            if (key) {
                this.key = key
                this.active = active
                this.searchBanners()
            }
        },
        async searchBanners() {
            var self = this
            console.log(self);
            this.$vs.loading({
                container: '#viewBannerLoadingDiv',
                scale: 0.6
            })

            await this.$store.dispatch("giftManagement/viewGifts")
                .then(res => {
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewBannerLoadingDiv > .con-vs-loading')
                })
                .catch(err => {
                    console.log(err);
                    this.$vs.loading.close('#viewBannerLoadingDiv > .con-vs-loading')
                })

            this.gifts = this.$store.state.giftManagement.gifts
        },
        async viewGifts() {
            var self = this
            this.$vs.loading();
            console.log(self);
            await this.$store.dispatch("giftManagement/viewGifts", { page: this.currentPage })
                .then(res => {
                    this.totalPage = res.data.last_page
                })

            this.gifts = this.$store.state.giftManagement.gifts
            this.$vs.loading.close()

        },
    },
    async created() {
        if (!moduleGiftManagement.isRegistered) {
            this.$store.registerModule('giftManagement', moduleGiftManagement)
            moduleGiftManagement.isRegistered = true
        }


    },
}
</script>
<style type="text/css">
::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

.vs-con-textarea {
    height: 400px;
}

.vs-textarea {
    height: 100%;
}
</style>

